import { User } from 'oidc-client';
import { USER_LOGOUT } from 'src/shared/services/redux/constants/userTypes';
import { store } from 'src/shared/services/redux/store';
import userManager from './userManager';

let loginRedirectStarted = false;

export const isAuthenticatedUser = (
  user: User | null | undefined,
): user is User => !!user && !user.expired && !!user.access_token;

export const getCurrentUser = () => store.getState().oidc.user;

export const getAccessToken = () => {
  const user = getCurrentUser();
  return isAuthenticatedUser(user) ? user.access_token : undefined;
};

export const renewUser = async () => {
  const user = await userManager.signinSilent();
  if (!isAuthenticatedUser(user)) {
    throw new Error('Silent renew did not return an active user.');
  }

  return user;
};

export const clearAppSession = async () => {
  store.dispatch({ type: USER_LOGOUT });
  await userManager.removeUser().catch(() => undefined);
};

export const redirectToLogin = async () => {
  if (loginRedirectStarted) return;

  loginRedirectStarted = true;
  try {
    await clearAppSession();
    await userManager.signinRedirect();
  } catch (error) {
    loginRedirectStarted = false;
    throw error;
  }
};
